import { WebGLRenderer } from 'three'

export const initializeRenderer = (canvas: HTMLCanvasElement, pxr: number) => {
  const renderer = new WebGLRenderer({
    canvas,
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true,
  })

  renderer.setSize(canvas.width, canvas.height)
  renderer.setPixelRatio(pxr)

  renderer.gammaFactor = 2.2
  renderer.gammaOutput = true

  return renderer
}
